import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { ErrorObject } from "serialize-error";

export const supabaseBaseQuery: BaseQueryFn<
  void,
  unknown,
  ErrorObject,
  object,
  object
> = async () => {
  throw new Error(
    "When using `supabaseBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.",
  );
};
